import { useContext } from "react";
import { ProfileContext } from "./Profile.context.js";
export function useProfile() {
    const profileContext = useContext(ProfileContext);
    return profileContext;
}
